import { createSelector } from "@reduxjs/toolkit";

// TODO 2381 avoid duplicated code if possible? (low prio)
export const selectRegularRoofs = createSelector(
  (state) => state.Options,
  (Options) => {
    const { Roofs } = Options;

    if (!Roofs || !Roofs.length) {
      return null;
    }

    const regularRoofs = Roofs.filter(
      (roof) =>
        !roof.Value.includes("ROOF_TIN") &&
        !roof.Value.includes("ROOF_SANDWICH")
    );

    return regularRoofs;
  }
);

export const selectTinRoofs = createSelector(
  (state) => state.Options,
  (Options) => {
    const { Roofs } = Options;

    if (!Roofs || !Roofs.length) {
      return null;
    }

    const tinRoofs = Roofs.filter((roof) => roof.Value.includes("ROOF_TIN"));

    return tinRoofs;
  }
);

export const selectSandwichRoofs = createSelector(
  (state) => state.Options,
  (Options) => {
    const { Roofs } = Options;

    if (!Roofs || !Roofs.length) {
      return null;
    }

    const sandwichRoofs = Roofs.filter((roof) =>
      roof.Value.includes("ROOF_SANDWICH")
    );

    return sandwichRoofs;
  }
);
